import { RiskSurveyQuestion } from '@shared/models/Strategy';

export function isGeneralRiskQuestionAndPrefilled(question?: RiskSurveyQuestion): boolean {
  if (!question) {
    return false;
  }

  return [1, 2, 3].includes(question.inyova_id) && (!!question.survey_customer_answer?.answer || question.hasAnswer);
}
